import { Component } from '@angular/core';
import { NavController, NavParams} from 'ionic-angular';
import { CategorySectionPage } from '../category-section/category-section';
import { BookmarksPage } from '../bookmarks/bookmarks';

@Component({
    selector: 'page-category-single',
	templateUrl: 'category-single.html'
})
export class CategorySinglePage {

    title: string;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.title = navParams.get('data');
    }

    /**
     * goToCategorySecton
     */
    public goToCategorySecton($item) {
        this.navCtrl.push(CategorySectionPage, {
            data: $item
        });
    }

    /**
       * goToBookmarks
    **/
    public addBookmark() {
        this.navCtrl.push(BookmarksPage, {});
    }


}



// WEBPACK FOOTER //
// ./src/pages/category-single/category-single.ts